import {Dispatch} from "redux";

import {createRequestActionTypes} from "@pg-mono/request-state";

import {addSuccessNotification} from "../../notifications/utils/add_success_notification";
import {IApplicationData} from "../types/IApplicationData";
import {alertFormSuccessMessage} from "../utils/form/application_form_alert_text";

const APPLICATION_PREFIX = `desktop/application/CREATE`;
export const postApplicationTypes = createRequestActionTypes(APPLICATION_PREFIX);

export const afterPostApplicationActions = (storeHash: string, applicationResponse: IApplicationData) => (dispatch: Dispatch) => {
    if (applicationResponse) {
        // dispatching postApplicationTypes.success makes sense because we store application response in redux - this can possibly be moved to ApplicationModalArray local state
        dispatch({type: postApplicationTypes.success, id: storeHash, result: applicationResponse});

        dispatch(addSuccessNotification(alertFormSuccessMessage));
    }
};
export const resetPostApplication = (id: string) => ({type: postApplicationTypes.reset, id});
import {Dispatch} from "redux";

import {createRequestActionTypes} from "@pg-mono/request-state";

import {addSuccessNotification} from "../../notifications/utils/add_success_notification";
import {IApplicationData} from "../types/IApplicationData";
import {alertFormSuccessMessage} from "../utils/form/application_form_alert_text";

const APPLICATION_PREFIX = `desktop/application/CREATE`;
export const postApplicationTypes = createRequestActionTypes(APPLICATION_PREFIX);

export const afterPostApplicationActions = (storeHash: string, applicationResponse: IApplicationData) => (dispatch: Dispatch) => {
    if (applicationResponse) {
        // dispatching postApplicationTypes.success makes sense because we store application response in redux - this can possibly be moved to ApplicationModalArray local state
        dispatch({type: postApplicationTypes.success, id: storeHash, result: applicationResponse});

        dispatch(addSuccessNotification(alertFormSuccessMessage));
    }
};
export const resetPostApplication = (id: string) => ({type: postApplicationTypes.reset, id});
